import React, { FC, memo } from "react";
import { ISvG } from "~/types/SvGTypes";

const Icon: FC<ISvG> = ({ fill = "#FFF", width, height }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 11 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.8656 10.2176L7.73749 7.0895C8.34341 6.34105 8.70823 5.39 8.70823 4.35417C8.70823 1.95342 6.75483 0 4.3541 0C1.95338 0 0 1.9534 0 4.35415C0 6.7549 1.9534 8.70833 4.35413 8.70833C5.38994 8.70833 6.34098 8.3435 7.08942 7.73758L10.2175 10.8657C10.3069 10.9551 10.4242 11 10.5416 11C10.6589 11 10.7762 10.9551 10.8656 10.8657C11.0448 10.6865 11.0448 10.3968 10.8656 10.2176ZM4.35413 7.79165C2.45847 7.79165 0.916664 6.24983 0.916664 4.35415C0.916664 2.45848 2.45847 0.916652 4.35413 0.916652C6.24978 0.916652 7.79159 2.45848 7.79159 4.35415C7.79159 6.24983 6.24976 7.79165 4.35413 7.79165Z"
        fill="#52616E"
      />
    </svg>
  );
};

export default memo(Icon);
